import React, { useEffect, useState } from 'react'
import { Button, Grid, Skeleton } from 'antd'
import { useSdk } from 'hooks/useSdk'
import { sdkService } from 'services'
import { Greetings, OrgCard, RecentTopics } from './components'
import { ActivityCard } from './components/Activities'
import { ApiOutlined, NotificationOutlined, TeamOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { useAuth } from 'auth-context'

export function UserDashboard() {
  const { orgs } = useSdk()
  const { xs } = Grid.useBreakpoint()
  const { user } = useAuth()

  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    setLoading(true)
    sdkService.fetchOrganizations()
      .catch((err) => console.log('Error fetching orgs', err))
      .finally(() => setLoading(false))
  }, [])

  return (
    <Skeleton active loading={loading}>
      <div 
        style={{
        justifyItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        width: '100%',
        gap: xs ? 12 : 18,
      }}>
        <Greetings />
        <ActivityCard 
          actions={[
            <Link to="/cad-plugins">
              <Button
                type='primary'
                style={{
                  width: '100%'
                }}
              >Download</Button>
            </Link>
          ]}
          title={'Get the Plugins'}
          description={'Download the latest version of Pollination plugins'} 
          icon={<ApiOutlined />}
        />
        <ActivityCard 
          title={'Manage Organizations and Subscriptions'} 
          icon={<TeamOutlined />}
          description={<>
            <Link to={`/${user?.username}/create-org`}>Create a new organization</Link> to start your Pollination journey or manage your existing organizations and subscriptions below.
          </>}
        />
        {orgs?.map((o) => (
          <OrgCard key={o.owner.id} info={o} />
        ))}
        <ActivityCard 
          title={'See What\'s New'} 
          icon={<NotificationOutlined />}
        />
        <RecentTopics />
      </div>
  </Skeleton>
  )
}
